module.exports = __webpack_public_path__ + "img/baleno-glx-prime-white.c37511c8.png";